import React, {Fragment} from "react";
import useGetOrganizations from "../views/Proactive/Utilities/hooks/useGetOrganizations";
import BasicFilterSelect from "./BasicFilterSelect";

export default function OrganizationFilterSelect({ placeholder, handleChange, input, meta }) {
    const { organizations } = useGetOrganizations();

    return(
        <Fragment>
            <BasicFilterSelect
                placeholder={placeholder}
                options={organizations}
                onChange={handleChange}
                input={input}
                meta={meta} />
        </Fragment>
    )
}